module.exports = __webpack_public_path__ + "img/MT800.74814330.jpg";